import { render, staticRenderFns } from "./SpaceForbidden.vue?vue&type=template&id=f061dafe"
import script from "./SpaceForbidden.vue?vue&type=script&lang=js"
export * from "./SpaceForbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports